import React from 'react';
import { legacy } from '../data/mock';
import { ExternalLink, Music2 } from 'lucide-react';

const Legacy = () => {
  return (
    <section id="legacy" className="py-20 bg-gradient-to-b from-black to-neutral-900">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        {/* Main CTA */}
        <div className="relative bg-gradient-to-r from-rose-900 via-rose-800 to-violet-900 rounded-3xl p-10 md:p-12 text-center overflow-hidden">
          {/* Decorative Background */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl"></div>
          </div>

          {/* Content */}
          <div className="relative z-10">
            {/* Logo */}
            <div className="flex justify-center mb-6">
              <img 
                src={legacy.logo} 
                alt="G.Lley' Lab Sound Logo" 
                className="h-56 w-auto filter drop-shadow-2xl"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            </div>

            <h2 className="font-display text-4xl md:text-5xl font-bold uppercase text-white mb-5 tracking-wide">
              {legacy.title}
            </h2>
            
            <p className="text-white/90 text-base md:text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
              {legacy.description}
            </p>

            {/* CTA Button */}
            <a
              href={legacy.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-black rounded-full font-bold uppercase text-sm tracking-wider hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-white/20"
            >
              {legacy.ctaText}
              <ExternalLink size={18} />
            </a>

            {/* Decorative Elements */}
            <div className="mt-8 flex flex-wrap justify-center gap-4 md:gap-6 text-white/60 text-xs">
              {legacy.highlights.map((highlight, index) => (
                <div key={index} className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                  <span>{highlight}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Legacy;
